module.exports = __webpack_public_path__ + "media/src/assets/face-only--no-crown-ac9d6abc0e4fc92d966346060bae4080.png";